import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap-icons/font/bootstrap-icons.css'


// 1. Importaciones de Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHome, faCogs, faUserTie, faMapMarkerAlt, faTools } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// 2. Añadir los iconos a la librería
library.add(faHome, faCogs, faUserTie, faMapMarkerAlt, faTools, faWhatsapp);

// 3. Registrar el componente global
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
